import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { getLoggedUser } from '../store/shared/selectors-shared';

@Directive({
    selector: '[appRoleBasedVisibility]',
    standalone: true,
})
export class RoleBasedVisibilityDirective implements OnInit, OnDestroy {

    @Input() allowedRoles: string[] = [];  // The allowed roles input

    private subscription: Subscription = Subscription.EMPTY; // Holds the subscription

    constructor(
        private el: ElementRef,  // To access the element
        private renderer: Renderer2,  // To manipulate the DOM
        private store: Store  // To access the user role from the store
    ) { }


    ngOnInit() {
        this.subscription = this.store.select(getLoggedUser).pipe(
            map(loggedUser => {
                if (loggedUser && loggedUser.userAttributes && loggedUser.userAttributes['custom:role']) {
                    const userRole = loggedUser.userAttributes['custom:role'];

                    // If user's role is not in allowedRoles, hide the element
                    if (!this.allowedRoles.includes(userRole)) {
                        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');  // Hide the element
                    } else {
                        this.renderer.removeStyle(this.el.nativeElement, 'display');  // Show the element if the role is allowed
                    }
                } else {
                    this.renderer.setStyle(this.el.nativeElement, 'display', 'none');  // Hide if no role is defined
                }
            })
        ).subscribe();
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();  // Unsubscribe when the directive is destroyed
        }
    }
}
